import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";
import { dishes } from "@/mocks/dishes";
import { MENU_LINK } from "@/mocks/restaurant";
import DishCard from "./DishCard";

export default function Signature() {
  const { t } = useTranslation();

  return (
    <section id="recomendados" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-5 md:px-10">
        <Reveal>
          <h2 className="text-center font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("signature.title")}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-center font-body text-base text-secondary-500">
            {t("signature.subtitle")}
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-12 md:mt-16 md:grid-cols-2 md:gap-y-10 lg:grid-cols-3">
          {dishes.map((dish, index) => (
            <DishCard key={dish.id} dish={dish} index={index} />
          ))}
        </div>

        <Reveal>
          <p className="mx-auto mt-14 max-w-2xl text-center font-body text-base leading-relaxed text-secondary-500 md:mt-16">
            {t("signature.note")}
          </p>
          <div className="mt-6 flex justify-center">
            <a
              href={MENU_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="press inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 font-body text-sm text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer sm:w-auto"
            >
              {t("signature.cta")}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}